import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";
import { OnScrollAnimation, FloatingAnimation, InViewTrigger, SetInitRandomPositions } from "@app/scripts/AnimationHelpers";

class Parallax {
	constructor() {
		this.parallax = document.querySelectorAll(".parallax");
		this.mousemoveElementsSelector = '[data-mousemove-animation]';

		gsap.registerPlugin(ScrollTrigger);

		this._scrollParallax();
		this._initAnimations();
		this._defineRandomMouseDirection();
		this._events();

	}

	_events() {
    window.addEventListener('mousemove', e => {
      this._mouseParallax(e);
    });
  }

	_defineRandomMouseDirection() {
	  const elements = gsap.utils.toArray([this.mousemoveElementsSelector]);

		if(!elements.length) {
			this.mouseEnabled = false;

			return
		}

	  elements.forEach((item) => {
	    item.randomMouseX = gsap.utils.random(-.05,  .05);
	    item.randomMouseY = gsap.utils.random(-.05,  .05);
	    item.randomScrollX = gsap.utils.random(-.1,  .1);
	    item.randomScrollY = gsap.utils.random(-.1,  .1);
	    item.randomRotate = gsap.utils.random(-1,  1);
	  });
	}

	_initAnimations() {
    const batchTrigger = gsap.utils.toArray(['[data-entering-animation="trigger"]']);
    const radomSetterElements = gsap.utils.toArray(['[data-entering-animation="element"]']);

		if(!radomSetterElements.length) {
			this.mouseEnabled = true

			return;
		};

    const setElementsBatch = batch => {
      const batchElements = [];

      batch.forEach(el => {
        const items = el.querySelectorAll('[data-entering-animation="element"]');
        items.forEach(item => batchElements.push(item));
      })

      return batchElements;
    }

		const onComplete = () => {this.mouseEnabled = true};
		SetInitRandomPositions(radomSetterElements);
		InViewTrigger(batchTrigger, setElementsBatch, onComplete);
  }

	_mouseParallax(e) {
		if(!this.mouseEnabled) return

    FloatingAnimation(e, this.mousemoveElementsSelector);
  }

	_scrollParallax() {
		this.parallax.forEach((element) => {
			const imgs = element.querySelectorAll(".atonal-parallax__img");
			const elementHeight = element.offsetHeight;
			const endPos = elementHeight * 1.5;

			gsap.registerPlugin(ScrollTrigger);

			imgs.forEach((img) => {
				const speed = img.getAttribute("data-speed").split(",");

				const positionX = speed[0] * endPos;
				const positionY = speed[1] * endPos;
				const customOptions = { end: `${endPos} top` };

				OnScrollAnimation(
					element,
					img,
					0,
					positionY,
					positionX,
					false,
					false,
					customOptions
				);
			});
		});
	}


}

const ParallaxClass = new Parallax();

export default ParallaxClass;
